// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14mAT","newExpiryDate":"styles_newExpiryDate__3QWIp","footer":"styles_footer__1YteQ"};